import Base from '../base'

function sendOrderIntegration(cafe_id, pos_name) {
    return Base.post(`/analytics/order_integration`, {
        cafe_id,
        pos_name
    });
}

export default {
    sendOrderIntegration
}